import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { RouteEnum } from '../../enums/routes.enum';
import { ByPassGuardService } from '../../services/by-pass-guard/by-pass-guard.service';

export interface CanComponentDeactivate {
	canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const saveChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
	component,
	currentRoute,
	currentState,
	nextState
) => {
	const destinationUrl = nextState?.url ?? '';
	const bypassGuardService = inject(ByPassGuardService);

	if (bypassGuardService.shouldBypass()) {
		return true;
	}

	const allowedRoutePrefixes = [
		`/${RouteEnum.COURSE_CREATION}`
	];

	const isAllowed = allowedRoutePrefixes.some(route =>
		destinationUrl.startsWith(route)
	);

	if (isAllowed) {
		return true;
	}

	return component.canDeactivate ? component.canDeactivate() : true;
};
